import { PropsWithChildren } from "react";
import { ScrollRadixArea as ScrollArea } from "@shortsworks/ui";

interface TableContainerProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {}
export const TableContainer = ({ children, ...props }: TableContainerProps) => {
  return (
    //   높이 체크 필요
    <ScrollArea.Root
      type="always"
      style={{ overflow: "hidden", width: "100%", height: "100%" }}
    >
      <ScrollArea.Viewport style={{ width: "100%", height: "100%" }}>
        <div className="block w-fit min-w-full size-3.5" {...props}>
          {children}
        </div>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar
        orientation="vertical"
        style={{ padding: "2px 2px 2px 0", zIndex: 999 }}
      >
        <ScrollArea.Thumb
          style={{
            background: "rgba(226,232,240,0.8)",
            width: "5px",
            borderRadius: "5px",
          }}
        />
      </ScrollArea.Scrollbar>
      <ScrollArea.Scrollbar
        orientation="horizontal"
        style={{ padding: "0 2px 2px 2px", zIndex: 999 }}
      >
        <ScrollArea.Thumb
          style={{
            background: "rgba(226,232,240,0.8)",
            height: "5px",
            borderRadius: "5px",
          }}
        />
      </ScrollArea.Scrollbar>
      <ScrollArea.Corner className="ScrollAreaCorner" />
    </ScrollArea.Root>
  );
};
